if (!customElements.get('size-chart-units')) {
  customElements.define(
    'size-chart-units',
    class SizeChartUnits extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick);
      }

      onClick(event) {
        const button = event.target.closest('.size-chart__unit');
        if (!button) return;

        // Both units are already in the markup, so switching is a data attribute
        // flip: no re-render, no conversion in the browser.
        this.dataset.unit = button.dataset.unit;

        this.querySelectorAll('.size-chart__unit').forEach((unitButton) => {
          unitButton.setAttribute('aria-pressed', unitButton === button ? 'true' : 'false');
        });
      }
    }
  );
}
